import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var _MenuWaterTower = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(MenuWrapper, { onClose: onClose, type: IdMenuBalancing.WaterTower, modalId: IdModal.WaterTower }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.WaterTower)); },
}); };
export var MenuWaterTower = connect(undefined, mapDispatch)(_MenuWaterTower);



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/MenuWaterTower.tsx
// module id = 2961
// module chunks = 3